//useGetImageUploadById

import { OnlinePatientManagementContext } from '@ngt/opms';
import { useContext, useEffect, useState } from 'react';
import { GetImageUploadById } from '../../api/dtos';

export const useGetImageUploadById = (id: number | undefined) => {
    const { serviceStackClient: client } = useContext(OnlinePatientManagementContext);

    // State to manage data, loading, and error
    const [data, setData] = useState<any>(null); // Replace `any` with the appropriate type for your data
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!id) {
            return;
        }

        const fetchData = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await client.get(
                    new GetImageUploadById({
                        id: id,
                    })
                );
                setData(response?.data);
            } catch (err: any) {
                setError(err.message || 'An error occurred while fetching data.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id, client]);

    return { data, loading, error };
};


export default useGetImageUploadById;


